export enum StockCategories {
	DISTRIBUTOR,
	SELF,
	SALE,
	VIRTUAL
}
